var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5358 8.92854C20.5358 14.2857 12.5001 20.5357 12.5001 20.5357C12.5001 20.5357 4.46436 14.2857 4.46436 8.92854C4.46436 4.55175 8.12328 0.892822 12.5001 0.892822C16.8769 0.892822 20.5358 4.55175 20.5358 8.92854Z",
    stroke: "#404040",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7803 17.8571H21.4285L24.1071 24.1071H0.892822L3.57139 17.8571H5.21961M12.5 11.6071C13.2104 11.6071 13.8917 11.3249 14.394 10.8226C14.8963 10.3203 15.1785 9.63897 15.1785 8.92857C15.1785 8.21817 14.8963 7.53687 14.394 7.03454C13.8917 6.53221 13.2104 6.25 12.5 6.25C11.7896 6.25 11.1083 6.53221 10.6059 7.03454C10.1036 7.53687 9.82139 8.21817 9.82139 8.92857C9.82139 9.63897 10.1036 10.3203 10.6059 10.8226C11.1083 11.3249 11.7896 11.6071 12.5 11.6071Z",
    stroke: "#404040",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationInactive);
export default __webpack_public_path__ + "static/media/locationInactive.34b65fce4889ebe023f3a08ad8a3fe4b.svg";
export { ForwardRef as ReactComponent };